import './front/accordion.js';
import './front/conditional-logic.js';
import './front/external-links.js';
import './front/form-disableonsubmit.js';
import './front/menu-offcanvas.js';
import './front/outdated-browser.js';
import './front/team.js';

const htmlElement = document.querySelector('html');
htmlElement.classList.remove('no-js');
htmlElement.classList.add('js');
